<div class="print-only">
  <div class="modal-body">
    <div id="passcode-container" class="container">
      <div class="row">
        <ng-container *ngIf="class.TeacherName">
          <div class="col-2 detail-header">Teacher</div>
          <div class="col-10">{{ class.TeacherName }}</div>
        </ng-container>

        <div class="col-2 detail-header">Class Name</div>
        <div class="col-10">{{ class.Description }}</div>

        <div class="col-2 detail-header">Class Code</div>
        <div class="col-10">{{ class.LoginCode }}</div>

        <div class="col-2 detail-header">Start</div>
        <div class="col-10">{{ class.StartingOn }}</div>

      </div>

      <label class="mt-2 students-title mb-0">Student Passcodes</label>
      <div class="row students-row passcode-wrapper">
        <div class="col-md-4 py-3" *ngFor="let obj of students">
          <div class="d-flex align-items-center passcode-item">
            <app-passcode [passcode]="obj.PassCode" [size]="passcodeSize"></app-passcode>
            <div class="student-name">{{ obj.Name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<span (click)="printDiv('passcode-container')" class="ml-4" ngbTooltip="Print student passcodes">
  <i class="icon-passcodes-icon fa-2x pointer"></i>
</span>